<template>
<v-container fluid>
    <v-layout style="flex-direction: column;">
        <v-flex>
            <v-data-table
                :headers="headers"
                :items="targets"
                class="elevation-1"
                :loading="loadigtable"
                loading-text="Loading... Please wait"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'skip_previous',
                    lastIcon: 'skip_next',
                    prevIcon: 'keyboard_arrow_left',
                    nextIcon: 'keyboard_arrow_right'
                }"
            >
                <template v-slot:[`item.opciones`]="{ item }" v-if="rolejecutivo === 'Administrador' || rolejecutivo === 'ComercialAdmin' || rolejecutivo === 'Marketing' ">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">                    
                            <v-icon
                            v-bind="attrs"
                            v-on="on"
                                small
                                class="mr-2"
                                @click="editItemP(item)"
                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                color="#3d5170"
                                >
                                edit
                            </v-icon>
                        </template>
                        <span>Edit</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">                    
                            <v-icon
                            v-bind="attrs"
                            v-on="on"
                                small
                                class="mr-2"
                                @click="Historial(item)"
                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                color="#3d5170"
                                >
                                list_alt
                            </v-icon>
                        </template>
                        <span>Historial</span>
                    </v-tooltip>
                    <template v-if="item.activo"> 
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">                    
                                <v-icon
                                v-bind="attrs"
                                v-on="on"
                                small
                                @click="activarDesactivarMostrar(2,item)"     
                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                color="#3d5170"         
                                >
                                block
                                </v-icon> 
                            </template>
                            <span>Desactivar</span>
                        </v-tooltip>
                    </template>
                    <template v-else>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">                    
                                <v-icon
                                v-bind="attrs"
                                v-on="on"
                                small 
                                @click="activarDesactivarMostrar(1,item)"                   
                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                color="#3d5170"
                                >
                                check
                                </v-icon>
                            </template>
                            <span>Activar</span>
                        </v-tooltip>
                    </template> 
                </template>
                <template v-slot:[`item.logro`]="{ item }">
                    <v-btn depressed block style="padding:0;">
                        <v-progress-linear
                        block
                        :color="color(item)"
                        height="25"
                        :value="promedio(item)"
                        @click="Historial(item)"
                        >
                        <strong><span style="color:#093474;">${{addCommas(parseFloat(item.logro).toFixed(2))}}</span> </strong>
                        </v-progress-linear><br>
                        <span style="width:150px;"><strong>{{ Math.ceil(promedio(item)) }}%</strong></span>
                    </v-btn>
                </template>
                <template v-slot:[`item.activo`]="{ item }">
                    <template v-if="item.activo === true">
                        <v-icon
                        small
                        class="mr-2"
                        style="color: #4CAF50;font-weight: 600;"
                        >
                        done
                        </v-icon>  
                    </template>
                    <template v-else>
                        <v-icon
                        small
                        class="mr-2"
                        style="color: red;font-weight: 600;"
                        >
                        clear
                        </v-icon> 
                    </template>
                </template>
                <template v-slot:top>
                    <v-toolbar flat color="white">
                        <v-toolbar-title>Targets</v-toolbar-title>
                        <v-divider
                            class="mx-4"
                            inset
                            vertical
                        ></v-divider>
                        <v-spacer></v-spacer>                        
                        <v-text-field style="margin-left:8px;" class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                        <v-spacer></v-spacer>
                        <v-btn style="margin-left:8px;" color="primary" @click="Limpiar(),dialogn = true" v-if="rolejecutivo === 'Administrador' || rolejecutivo === 'Marketing'">Nuevo Target</v-btn>
                        <v-spacer></v-spacer>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                v-bind="attrs"
                                v-on="on"
                                    class="mr-2"
                                    @click="listar()"
                                    style="color: #1583da;font-weight: 600;"
                                    >
                                    refresh
                                </v-icon>
                            </template>
                            <span>Refresh</span>
                        </v-tooltip>
                        <v-dialog
                            v-model="dialogn"
                            width="800"
                        >
                            <v-card
                            >
                                <v-card-title style="color: #115bb7;">
                                    {{formTitle}}
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text ><br>
                                    <v-row>
                                        <v-col sm="4" md="4" lg="4">
                                            <v-select style="width:280px;margin-top:4px;" label="Executive" dense outlined v-model="ejecutivos" :items="usuarios"></v-select>
                                        </v-col>
                                        <v-col sm="3" md="3" lg="3">
                                            <v-text-field v-model="rate" type="number" style="width:150px; margin-left:8px;margin-top:4px;" outlined dense prefix="$" placeholder="rate"></v-text-field>
                                        </v-col>
                                        <v-col  style="display: flex;align-items: center;">
                                            <v-menu
                                                v-model="vigenciainicio"
                                                :close-on-content-click="false"
                                                max-width="290"
                                                dense
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                    :value="computedDateFormattvigenciainicio"
                                                    clearable
                                                    label="*vigencia Inicio"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click:clear="fechavigenciainicio= null"
                                                    dense
                                                    outlined
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="fechavigenciainicio"
                                                    @change="vigenciainicio = false"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col  style="display: flex;align-items: center;">
                                            <v-menu
                                                v-model="vigencia"
                                                :close-on-content-click="false"
                                                max-width="290"
                                                dense
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                    :value="computedDateFormattvigencia"
                                                    clearable
                                                    label="*vigencia Fin"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click:clear="fechavigencia= null"
                                                    dense
                                                    outlined
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="fechavigencia"
                                                    @change="vigencia = false"
                                                ></v-date-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                    color="error"
                                    @click="dialogn = false"
                                >
                                    Cancelar
                                </v-btn>
                                <v-btn
                                    color="primary"
                                    @click="guardar()"
                                >
                                    Save
                                </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-toolbar>
                </template> 
                <template v-slot:no-data>
                <v-btn
                    color="primary"
                >
                    Reset
                </v-btn>
                </template> 
            </v-data-table><br>
            <v-dialog v-model="historialtarget" persistent>
                <v-card>
                    <v-toolbar>
                        <span style="font-size: 12pt;color: #1d4980; font-weight:600;" > <v-icon style="font-size: 18pt;color: #1d4980;">person</v-icon> {{nusuario}}   </span><span style="font-size: 12pt;color: #1d4980; font-weight:600;margin: 0 10px;">Periodo del  {{Finicio}}</span> <span style="font-size: 12pt;color: #1d4980; font-weight:600;"> al </span><span style="font-size: 12pt;color: #1d4980; font-weight:600;margin: 0 10px;">{{Ffin}}</span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="historialtarget = false"><v-icon>clear</v-icon></v-btn>
                    </v-toolbar>
                    <v-card-text><br>
                        <v-data-table
                            :headers="headersv"
                            :items="venta"
                            hide-default-footer="false"
                            :items-per-page="pagina"
                            class="elevation-1"
                        >
                        <template v-slot:[`item.comprat`]="{ item }">
                            <span style="font-size: 10px;">{{addCommas(item.comprat)}}</span>
                        </template>
                        <template v-slot:[`item.receipt`]="{ item }">
                            <span style="font-size: 10px;" v-if="item.receipt == 'SELECT..'">-</span>
                            <span v-else>{{item.receipt}}</span>
                        </template>
                        <template v-slot:[`item.loading`]="{ item }">
                            <span style="font-size: 10px;" v-if="item.loading == 'SELECT..'">-</span>
                            <span v-else>{{item.loading}}</span>
                        </template>
                        <template v-slot:[`item.discharge`]="{ item }">
                            <span style="font-size: 10px;" v-if="item.discharge == 'SELECT..'">-</span>
                            <span v-else>{{item.discharge}}</span>
                        </template>
                        <template v-slot:[`item.delivery`]="{ item }">
                            <span style="font-size: 10px;" v-if="item.delivery == 'SELECT..'">-</span>
                            <span v-else>{{item.delivery}}</span>
                        </template>
                        </v-data-table>
                        <div style="text-align: end;">
                            <table style="width:100%;">
                                <tr>
                                    <td  style="text-align: end;width:95%;color:black;">
                                        <strong><span>TOTAL:</span></strong>
                                    </td>
                                    <td style="text-aling:center;color:black;" v-if="ntotal > 0">
                                        <strong><span>{{addCommas(parseFloat(ntotal).toFixed(2))}}</span></strong>
                                    </td>
                                    <td style="text-aling:center;color:red;" v-else>
                                        <strong><span>{{addCommas(parseFloat(ntotal).toFixed(2))}}</span></strong>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn
                            text
                            @click="historialtarget = false"
                        >Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-flex>
    </v-layout>
</v-container>  
</template>
<script>
import axios from 'axios'
export default {
    data(){
        return{
            sortBy: 'activo',
            sortDesc: true,
            loadigtable:false,
            nusuario:'',
            Finicio:'',
            Ffin:'',
            pagina:-1,
            historialtarget:false,
            rate:'',
            ejecutivos:0,
            fechavigenciainicio:null,
            fechavigencia:null,
            vigencia:false,
            vigenciainicio:false,
            dialogn:false,
            search:'',
            targets:[],
            venta:[],
            headers: [
                {text:'Opciones', value: 'opciones', sortable: false,align:'center' },
                {text:'Usuario',sortable: false,value: 'nusuario',align:'center'},
                {text:'Objetivo', value: 'nrate',align:'center' },
                {text:'Venta', value: 'logro',align:'center' },
                {text:'Vigencia Inicio', value: 'nvigenciainicio' ,align:'center'},
                {text:'Vigencia Fin', value: 'nvigenciafin' ,align:'center'},
                {text:'Activo', value: 'activo' ,align:'center'},
            ],
            headersv: [
                {text:'BS',sortable: false,value: 'nbuysell',align:'center'},
                {text:'CUSTOMER NAME', value: 'custumer',align:'center' },
                {text:'BASIS', value: 'basis',align:'center' },
                {text:'MODALITY', value: 'modalidad' ,align:'center'},
                {text:'OPERATION TYPE', value: 'tipoOp' ,align:'center'},
                {text:'PLACE OF RECEIPT', value: 'receipt' ,align:'center'},
                {text:'POL', value: 'loading' ,align:'center'},
                {text:'POD', value: 'discharge' ,align:'center'},
                {text:'FINAL DESTINATION', value: 'delivery' ,align:'center'},
                {text:'VENTA', value: 'ventat' ,align:'center'},
                {text:'COMPRA', value: 'comprat' ,align:'center'},
                {text:'PROFIT', value: 'profitt' ,align:'center'},
            ],
            editedIndex:-1,
            usuarios:[],
            porsentajecumplido:0,
            ncolor:'',
            rolejecutivo:'',
            ntarget:0,
            finicio:'',
            ffin:'',
            totalprofit:0,
            BuySellLista:[],
            ntotal:0,
        }
    },
     computed: {
        formTitle () {//si editedIndex es igual a menos uno estamos agregando un dato nuevo de lo contrario vamos a editar un dato existente
            return this.editedIndex === -1 ? 'New Target' : 'Update Target'
        },
        computedDateFormattvigencia () {
            return this.formatDate(this.fechavigencia)
        },
        computedDateFormattvigenciainicio () {
            return this.formatDate(this.fechavigenciainicio)
        },
    },
    created () {        
        this.listar();
        this.select();
    },
    methods:{
        listar(){
            this.rolejecutivo = this.$store.state.usuario.rol;
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var admin = false;
            me.targets = [];
            me.BuySellLista = [];
            me.loadigtable = true;
            if(me.$store.state.usuario.rol == 'ComercialAdmin' || me.$store.state.usuario.rol == 'Administrador' || me.$store.state.usuario.rol == 'Marketing'){
                admin = true;
            }else{
                admin = false;
            }
            var targets = [];
            axios.get('api/targets/Listar/' + me.$store.state.usuario.idusuario + '/' + admin,configuracion).then(function(response){
                targets=response.data;
                console.log('targets')
                console.log(targets)
                targets.map(function(x){
                    if(me.finicio != null && me.ffin != null){
                        axios.get('api/Buysells/ReporteTarget/' + x.idusuario + '/' + x.vigenciainicio + '/' + x.vigenciafin,configuracion).then(function(response){
                            me.BuySellLista = response.data;
                            console.log('me.BuySellLista')
                            console.log(x.vigenciainicio)
                            console.log(x.vigenciafin)
                            console.log(me.BuySellLista)

                            var totalprofit = 0;
                            me.BuySellLista.map(function(y){
                                totalprofit = totalprofit + y.profitt;
                            })
                            me.targets.push({
                                nusuario:x.nusuario,
                                nrate:'USD $ '+me.addCommas(parseFloat(x.rate).toFixed(2)),
                                rate:x.rate,
                                logro:totalprofit,
                                nvigenciainicio:x.nvigenciainicio,
                                nvigenciafin:x.nvigenciafin,
                                vigenciafin:x.vigenciafin,
                                vigenciainicio:x.vigenciainicio,
                                activo:x.activo,
                                idusuario:x.idusuario,
                            });
                            me.loadigtable = false;
                        }).catch(function(error){
                            console.log(error);
                            me.loadigtable = false;
                        });
                    }
                });
            }).catch(function(error){
              console.log(error);
            });
            
        },
        total(){ 
            this.totalprofit = 0; 
            for(var i = 0; i < this.BuySellLista.length; i++){
                this.totalprofit = this.totalprofit + this.BuySellLista[i].profitt;
            }

        },
        Historial(item){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            me.venta = [];
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            me.Finicio = item.nvigenciainicio;
            me.Ffin = item.nvigenciafin;
            me.nusuario = item.nusuario;
            me.ntotal = 0;
            axios.get('api/targets/ReporteTarget/' + item.idusuario + '/'+ item.vigenciainicio + '/' + item.vigenciafin ,configuracion).then(function(response){
                console.log(response.data)
                me.venta = response.data;
                me.venta.map(function(y){
                    me.ntotal = me.ntotal + y.profitt;
                })
                me.historialtarget = true;
            }).catch(function(error){
              console.log(error);
            });
        },
        select(){
            var usuariosArray = [];
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.get('api/Usuarios/SelectReport',configuracion).then(function(response){
                usuariosArray=response.data;
                usuariosArray.map(function(x){
                    me.usuarios.push({text:x.nombre,value:x.idusuario});
                });            
            }).catch(function(error){
                console.log(error);
            });
        },
        Limpiar(){
            this.ejecutivos = '';
            this.rate = '';
            this.fechavigencia = null;
            this.fechavigenciainicio = null;
        },
        guardar(){3
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            if (this.editedIndex > -1) {
                axios.put('api/targets/Actualizar',{
                    'idtarget':me.editedIndex,
                    'idusuario':me.ejecutivos,
                    'rate':me.rate,
                    'nrate':me.addCommas(me.rate),
                    'vigenciainicio':me.fechavigenciainicio,
                    'vigenciafin':me.fechavigencia
                },configuracion).then(function(response){
                    me.dialogn = false;
                    me.Limpiar();
                    me.listar();
                    me.editedIndex = -1;
                    window.alert('Actualizado Correctamente');
                }).catch(function(error){
                    console.log(error);
                });
            }else{
                axios.post('api/targets/Crear',{
                    'idusuario':me.ejecutivos,
                    'rate':me.rate,
                    'nrate':me.addCommas(me.rate),
                    'vigenciainicio':me.fechavigenciainicio,
                    'vigenciafin':me.fechavigencia
                },configuracion).then(function(response){
                    me.dialogn = false;
                    me.Limpiar();
                    me.listar();
                    window.alert('Guardado Correctamente');
                }).catch(function(error){
                    console.log(error);
                });
            } 
        },
        editItemP(item){
            this.editedIndex = item.idtarget;
            this.ejecutivos = item.idusuario;
            this.rate = item.rate;
            this.fechavigencia = item.nvigenciafin;
            this.fechavigenciainicio = item.nvigenciainicio;
            this.dialogn = true;
        },
        formatDate(date){
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        addCommas(nStr) {
            nStr += '';
            var x = nStr.split('.');
            var x1 = x[0];
            var x2 = x.length > 1 ? '.' + x[1] : '';
            var rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 + x2;
        },
        color(item){
            var ncolor
            var porsentajecumplido = (item.logro / item.rate) * 100;
             if(porsentajecumplido <= 50 ){
                ncolor="rgb(255,17,0)";
            }
            if(porsentajecumplido > 50 && porsentajecumplido <= 75){
                ncolor="#2196f3";
            }
            if(porsentajecumplido > 75 ){
                ncolor="#4caf50";
            }
            return ncolor;
        },
        promedio(item){
           return (item.logro / item.rate) * 100;
        }
    }
}
</script>